<script>
import { defineComponent as _defineComponent } from "vue";
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, inject, computed, onMounted, watch } from "vue";
import { unrefElement } from "@vueuse/core";
import defu from "defu";
import {
  animate
} from "motion";
import { MagicScrollProgress } from "../symbols";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicScrollMotion",
  props: {
    sequence: { type: Array, required: true },
    sequenceOptions: { type: Object, required: false },
    progress: { type: Number, required: false }
  },
  setup(__props) {
    const animation = ref(void 0);
    const elRef = ref(void 0);
    const injectedProgress = inject(
      MagicScrollProgress,
      computed(() => 0)
    );
    const mappedProgress = computed(() => {
      return __props.progress || injectedProgress.value || 0;
    });
    const defaultSequenceOptions = {
      duration: 1,
      delay: 0
    };
    const mappedSequenceOptions = defu(__props.sequenceOptions, defaultSequenceOptions);
    function createAnimation() {
      const el = unrefElement(elRef);
      if (!__props.sequence || !__props.sequence.length || !el) {
        return;
      }
      const mappedSequence = __props.sequence.map((item) => {
        const [animation2 = [], options = {}] = item;
        return [el, animation2, options];
      });
      animation.value = animate(mappedSequence, mappedSequenceOptions);
      animation.value.pause();
      animation.value.time = mappedProgress.value;
    }
    watch(mappedProgress, (value) => {
      if (!value && value !== 0 || !animation.value) {
        return;
      }
      animation.value.time = value;
    });
    watch(
      () => __props.sequence,
      () => {
        createAnimation();
      },
      {
        deep: true
      }
    );
    onMounted(() => {
      createAnimation();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(
        "div",
        {
          ref_key: "elRef",
          ref: elRef,
          class: "magic-scroll-motion"
        },
        [
          _renderSlot(_ctx.$slots, "default")
        ],
        512
        /* NEED_PATCH */
      );
    };
  }
});
</script>
